import React, { useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
import { Divider, Paper } from "@mui/material";
import { useMaterialUIController } from "context";

function SetSuperGeofence() {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const handleFixGeofence = async () => {
    setLoading(true);
    setSnackbar(null);

    try {
              const token = localStorage.getItem("token");

      const response = await axios.get(
        "https://v3.dhundhoo.com/superAdmin/super/fix_geofences",
        {
          headers: {
            "x-dhundhoo-session":token
             
          },
        }
      );

      console.log("API Response:", response.data);

      setSnackbar({
        color: "success",
        icon: "check",
        title: "Success",
        content: "Geofences reset successfully for all organisations!",
        open: true,
      });
    } catch (error) {
      console.error("Fix Geofence Error:", error);
      setSnackbar({
        color: "error",
        icon: "warning",
        title: "Error",
        content:
          error.response?.data?.message || "Failed to reset geofences.",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      minHeight="80vh"
      bgcolor="#f5f7fa"
      p={4}
    >
        <Paper
        elevation={6}
        style={{
          borderRadius: "16px",
          padding: "32px",
          width: "100%",
          maxWidth: "650px",
          backgroundColor: darkMode ? "#344767" : "#fff",
        }}
      >
        {/* Title */}
       <MDTypography
          variant="h5"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
            color={darkMode ? "white" : undefined}

        >
          Reset Geofences For All Organisations
        </MDTypography>

        <Divider sx={{ mb: 3 }} />

        {/* Button */}
        <MDBox display="flex" justifyContent="center" mt={2}>
          <MDButton
            variant="contained"
            color="info"
            size="medium"
            onClick={handleFixGeofence}
            disabled={loading}
          >
            {loading ? "Processing..." : "Super GeoFence"}
          </MDButton>
        </MDBox>
      </Paper>

{snackbar && (
  <MDSnackbar
    color={snackbar.color}
    icon={snackbar.icon}
    title={snackbar.title}
    content={snackbar.content}
    open={snackbar.open}
    onClose={() => setSnackbar({ ...snackbar, open: false })}
    close={() => setSnackbar({ ...snackbar, open: false })} // ✅ must be a function
  />
)}

     
    </MDBox>
  );
}

export default SetSuperGeofence;